import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/geist/index.css";
import "@fontsource/geist/500.css";
import "@fontsource/geist/600.css";
import "@fontsource/geist-mono/index.css";
import "./app/globals.css";
import App from "./App";
import { installAppVersionWatch } from "./lib/app-version";

installAppVersionWatch();

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
